module.exports = __webpack_public_path__ + "assets/img/27_1774.65df38e9.jpg";